module.exports = __webpack_public_path__ + "static/jimmy-481530167967f9d62858e5852bc83c5a.jpeg";